var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DADC4F",
    d: "M2.034 3.924c.135 3.62 1.632 4.52 4.432 5.439l.173.056.18.058c2.872.966 3.1 3.434 2.826 4.129-.583.306-3.33 1.037-5.986-.884-2.655-1.92-2.8-4.753-2.595-6.174.205-1.421.888-2.624.97-2.624zM6.883 1h.274c.918.007 2.819.161 4.807 2.764C13.12 5.277 13.666 7.27 13.6 9.743c-1.021 2.48-2.745 3.354-3.159 3.539l-.012.005-.064.028c.202-2.293-1.173-3.867-4.125-4.72-3.552-.9-3.712-3.306-3.73-3.998l-.003-.11-.002-.04C2.39 1.962 5.702 1.011 6.883 1zm4.35 1.131c.914.566 1.631 1.413 2.152 2.542a6.518 6.518 0 0 1 .57 3.537 10.193 10.193 0 0 0-.773-3.345 7.612 7.612 0 0 0-1.949-2.734z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.3d3a1d9a0e96e225c04809bfbafcc02f.svg";
export { ForwardRef as ReactComponent };